import { FC, useState } from "react";
import { useTranslation } from 'react-i18next';
import SurveyResult1 from "./SurveyResult1";
import SurveyResult2 from "./SurveyResult2";
import SurveyResult3 from "./SurveyResult3";
import SurveyResult4 from "./SurveyResult4";

enum Contents {
  Category,
  ChoiceQuestion,
  EssayForm,
  Student
}

interface IProps {
  surveyCode: number|undefined;
}

const SurveyResult: FC<IProps> = ({
  surveyCode,
}) => {
  const { t } = useTranslation();
  const [content, setContent] = useState<Contents>(Contents.Category);

  const renderContent = () => {
    switch (content) {
      case Contents.Category:
        return <SurveyResult1 surveyCode={surveyCode} />;
      case Contents.ChoiceQuestion:
        return <SurveyResult2 surveyCode={surveyCode} />;
      case Contents.EssayForm:
        return <SurveyResult3 surveyCode={surveyCode} />;
      case Contents.Student:
        return <SurveyResult4 surveyCode={surveyCode} />;
    }
  }

  return (
    <>
      <div className="">
        <div className="comm-tab__line">
          <ul>
            <li className={(
                  content === Contents.Category
                    ? ' active'
                    : ''
                )}>
              <a className="btn-item" onClick={() => setContent(Contents.Category)}>
                {t('common.column.category')}
              </a>
            </li>
            <li className={(
                  content === Contents.ChoiceQuestion
                    ? ' active'
                    : ''
                )}>
              <a className="btn-item" onClick={() => setContent(Contents.ChoiceQuestion)}>
                {t('homepage.survey.tab1')}
              </a>
            </li>
            <li className={(
                  content === Contents.EssayForm
                    ? ' active'
                    : ''
                )}>
              <a className="btn-item" onClick={() => setContent(Contents.EssayForm)}>
                {t('homepage.survey.tab2')}
              </a>
            </li>
            <li className={(
                  content === Contents.Student
                    ? ' active'
                    : ''
                )}>
              <a className="btn-item" onClick={() => setContent(Contents.Student)}>
                {t('homepage.survey.tab3')}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="tab-content" id="custom-tabs-tabContent">
            {renderContent()}
          </div>
        </div>
      </div>
    </>
  );
}

export default SurveyResult;
